export interface ContentData {
  action: string;
  url: string;
  contentUrl?: string; // additional data when it comes to sponsors and promotions
  fileName: string;
  file: any;
  type: string;
  category?: string;
  extension: string;
}

export interface UploadResponse {
  name:string,
  url:string,
  extension: string,
  category?: string
  statusCode: number;
  message:string;
  fileData?: {
    fileName: string,
    fileSize: number
  };
}
export interface UploadRequestMetaData {
  path:string,
  method:string,
}
export enum UploadScenarios {
  entFontUpload,
  expertVideo,
  entLogo,
  entSponsor,
  adminProfile,
  expertProfile,
  expertBadge,
  expertSponsor,
  expertContent,
  articleBanner,
  sessionBanner,
  sessionFeedback,
  groupBanner,
  formBadge,
  generateThumbnail,
  scorm,
  textBlock,
}
export interface IUploadConfig {
  allowedExtensions:string[],
  sizeLimit:number,
}

export enum FileExtensions {
  jpg = '.jpg',
  jpeg = '.jpeg',
  png = '.png',
  gif = '.gif',
  mp4 = '.mp4',
  woff = '.woff',
  woff2 = '.woff2',
  pdf = '.pdf',
  mkv = '.mkv',
  mov = '.mov',
  wmv = '.wmv',
  flv = '.flv',
  webm = '.webm',
  zip = '.zip',
}

export enum UploadPaths {
  REVIEW_TOOL = 'review-tool-recordings',
}
